
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { ScrollArea } from "@/components/ui/scroll-area"
import { Assessment } from "../types"
import { OrderTableRow } from "./OrderTableRow"
import { useState } from "react"
import { ConfirmDialog } from "@/components/ui/confirm-dialog"

interface OrderHistoryTableProps {
  assessments: Assessment[]
  onSelectOrder: (order: Assessment) => void
  onDeleteDraft?: (assessmentId: string) => Promise<void>
}

export const OrderHistoryTable = ({ assessments, onSelectOrder, onDeleteDraft }: OrderHistoryTableProps) => {
  const [assessmentToDelete, setAssessmentToDelete] = useState<Assessment | null>(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // Sort assessments by date, newest first
  const sortedAssessments = [...assessments].sort((a, b) => 
    new Date(b.created_at || '').getTime() - new Date(a.created_at || '').getTime()
  )

  console.log('Sorted assessments for order history:', sortedAssessments)

  const handleDeleteClick = (assessment: Assessment) => {
    setAssessmentToDelete(assessment);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (assessmentToDelete && onDeleteDraft) {
      await onDeleteDraft(assessmentToDelete.id);
      setShowDeleteConfirm(false);
      setAssessmentToDelete(null);
    }
  };

  return (
    <>
      <ScrollArea className="h-[400px] border rounded-md">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Request Type</TableHead>
              <TableHead>Medication</TableHead>
              <TableHead>Dose Type</TableHead>
              <TableHead>Duration</TableHead>
              <TableHead>Amount</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedAssessments.map((assessment) => (
              <OrderTableRow
                key={assessment.id}
                assessment={assessment}
                onClick={() => onSelectOrder(assessment)}
                onDelete={onDeleteDraft ? handleDeleteClick : undefined}
              />
            ))}
          </TableBody>
        </Table>
      </ScrollArea>

      <ConfirmDialog
        open={showDeleteConfirm}
        onOpenChange={setShowDeleteConfirm}
        title="Delete Draft Assessment"
        description="Are you sure you want to delete this draft assessment? This action cannot be undone."
        confirmLabel="Delete"
        cancelLabel="Cancel"
        variant="destructive"
        onConfirm={confirmDelete}
      />
    </>
  )
}
